import React from "react";

class Search extends React.Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.input = React.createRef();
  }

  updateTimer(value) {
    if (this.props.onValueChange) {
      this.props.onValueChange(value);
    }

    clearTimeout(this.timer);

    if (!value) {
      this.props.onTypingEnd(value)
    } else {
      this.timer = setTimeout(() => this.props.onTypingEnd(value), 1000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    return <form role="search" onSubmit={ event => {
        event.preventDefault();
        clearTimeout(this.timer);
        this.props.onTypingEnd(this.input.current.value);
        if (window.matchMedia("(pointer: coarse)").matches) {
          this.input.current.blur(); // closes the on-screen keyboard so the results are visible
        }
      } }>
      <input
        ref={this.input}
        defaultValue={this.props.value || ""}
        autoComplete="off"
        type="search"
        enterKeyHint="search"
        placeholder={this.props.placeholder}
        className={"search-field " + (this.props.className ? this.props.className : "")}
        id={this.props.id}
        onChange={event => this.updateTimer(event.target.value)}
      />
    </form>;
  }
}

export default Search;
